import { useMemo } from 'react';
import { Refresh4LineIcon, Space, Text } from 'ui';

type P = {
  type?: 'daily' | 'monthly' | 'weekly';
};

const Repeats = ({ type }: P) => {
  const text = useMemo(() => {
    switch (type) {
      case 'daily':
        return 'Repeats daily';
      case 'monthly':
        return 'Repeats monthly';
      case undefined:
        return 'No repeat';
      case 'weekly':
        return 'Repeats weekly';
    }
  }, [type]);

  if (!type) {
    return null;
  }

  return (
    <Space size="xxs">
      <Refresh4LineIcon size="extra-small" /> <Text>{text}</Text>
    </Space>
  );
};

export default Repeats;
